// extracted by mini-css-extract-plugin
export default {"userChat":"Chats_userChat__h9Bti"};